import React from 'react';
import Loadable from 'react-loadable';
import AppLoader from '../../components/Loaders/AppLoader/AppLoader';

/** Import components asynchronously **/
export const Home = Loadable({
  loader: () => import('../../pages/Home'),
  loading: () => <AppLoader />,
});

export const AllClassrooms = Loadable({
  loader: () => import('../../pages/AllClassrooms'),
  loading: () => <AppLoader />,
});

export const AllEducators = Loadable({
  loader: () => import('../../pages/AllEducators'),
  loading: () => <AppLoader />,
});

export const Certificate = Loadable({
  loader: () => import('../../pages/Certificate'),
  loading: () => <AppLoader />,
});

export const ResetPassword = Loadable({
  loader: () => import('../../pages/ResetPassword'),
  loading: () => <AppLoader />,
});

export const ResetPasswordVerify = Loadable({
  loader: () => import('../../pages/ResetPasswordVerify'),
  loading: () => <AppLoader />,
});

export const ClassroomView = Loadable({
  loader: () => import('../../pages/ClassroomView'),
  loading: () => <AppLoader />,
});

export const NotFound = Loadable({
  loader: () => import('../../components/NotFound/NotFound'),
  loading: () => <AppLoader />,
});

export const Settings = Loadable({
  loader: () => import('../../pages/Settings'),
  loading: () => <AppLoader />,
});

export const EducatorRequest = Loadable({
  loader: () => import('../../pages/EducatorRequest'),
  loading: () => <AppLoader />,
});

export const EmailVerify = Loadable({
  loader: () => import('../../pages/EmailVerify'),
  loading: () => <AppLoader />,
});

export const UserMe = Loadable({
  loader: () => import('../../pages/UserMe'),
  loading: () => <AppLoader />,
});

export const MyClassrooms = Loadable({
  loader: () => import('../../pages/MyClassrooms'),
  loading: () => <AppLoader />,
});

export const CreateClassroom = Loadable({
  loader: () => import('../../pages/CreateClassroom'),
  loading: () => <AppLoader />,
});

export const UserOther = Loadable({
  loader: () => import('../../pages/UserOther'),
  loading: () => <AppLoader />,
});

export const UserMeEdit = Loadable({
  loader: () => import('../../pages/UserMeEdit'),
  loading: () => <AppLoader />,
});

export const ClassroomEdit = Loadable({
  loader: () => import('../../pages/ClassroomEdit'),
  loading: () => <AppLoader />,
});

export const ClassroomMe = Loadable({
  loader: () => import('../../pages/ClassroomMe'),
  loading: () => <AppLoader />,
});

export const Lectures = Loadable({
  loader: () => import('../../pages/Lectures'),
  loading: () => <AppLoader />,
});

export const LectureView = Loadable({
  loader: () => import('../../pages/LectureView'),
  loading: () => <AppLoader />,
});

export const Assignments = Loadable({
  loader: () => import('../../pages/Assignments'),
  loading: () => <AppLoader />,
});

export const CreatorAssignmentView = Loadable({
  loader: () => import('../../pages/CreatorAssignmentView'),
  loading: () => <AppLoader />,
});

export const MemberAssignmentView = Loadable({
  loader: () => import('../../pages/MemberAssignmentView'),
  loading: () => <AppLoader />,
});

export const AssignmentSubmissionView = Loadable({
  loader: () => import('../../pages/AssignmentSubmissionView'),
  loading: () => <AppLoader />,
});

export const AssignmentAllSubmissionsView = Loadable({
  loader: () => import('../../pages/AssignmentAllSubmissionsView'),
  loading: () => <AppLoader />,
});

export const Chat = Loadable({
  loader: () => import('../../pages/Chat'),
  loading: () => <AppLoader />,
});

export const LiveStream = Loadable({
  loader: () => import('../../pages/LiveStream'),
  loading: () => <AppLoader />,
});

export const Events = Loadable({
  loader: () => import('../../pages/Events'),
  loading: () => <AppLoader />,
});

export const ClassroomSettings = Loadable({
  loader: () => import('../../pages/ClassroomSettings'),
  loading: () => <AppLoader />,
});
